// extracted by mini-css-extract-plugin
export default {"wrapperInfobulle":"note_wrapperInfobulle__04hXl","questionMark":"note_questionMark__cy2aS","contentModal":"note_contentModal__OvdyW","right":"note_right__QHkuE"};